import { Theme, css } from '@emotion/react';

import { Radius, Typography } from 'chatie-design-system';

import { useGlobalContext } from '@contexts/global';
import { IPlayer, IUserDetail } from '@model';
import { formatKoreanCompactNumber } from '@utils/number';

const containerCSS = (isCheming?: boolean) => (theme: Theme) =>
  css`
    ${Typography.body12};
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${isCheming ? theme.colors.main50 : theme.var.gray900};
    color: ${isCheming ? theme.var.black : theme.var.white};
    padding: 19px 0;
    margin: ${isCheming ? '0px 0px 20px' : '16px 0'};
    border-radius: ${Radius.medium}px;
    font-weight: 400;

    .count {
      font-size: 14px;
      line-height: 14px;
      font-weight: 600;
      margin-top: 10px;
    }
  `;

interface PlayCountCardProps {
  isMyPage?: boolean;
  user?: IUserDetail;
  player?: IPlayer;
}

const PlayCountCard = ({ isMyPage, user, player }: PlayCountCardProps) => {
  const { isCheming } = useGlobalContext();

  const text = isCheming ? '이만큼 대화했어요 💬' : '이만큼 플레이 했어요 👀';
  return (
    <div css={containerCSS(isCheming)}>
      <p>
        {isMyPage
          ? '유저들이 내 캐릭터를 '
          : `${user?.nickname}님의 캐릭터를 유저들이 `}
        {text}
      </p>
      <p className="count">
        {formatKoreanCompactNumber(
          player?.stat?.my_character_message_count || 0
        ) === '0'
          ? '-'
          : formatKoreanCompactNumber(
              player?.stat?.my_character_message_count || 0
            )}
      </p>
    </div>
  );
};

export default PlayCountCard;
